<section class="content">
  <div class="card" style="padding:25px" *ngIf="!show_grn_table && !show_product_goods_table">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
      <div class="col" style="text-align: right;">
        <button mat-button (click)="enableGrn()"
          style="background: #64073d;border-radius: 10px; font-size: 23px; color: white;">New GRN</button>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="!is_data_available">
    <div class="col">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
      </mat-progress-spinner>
    </div>
  </div>
  <div class="row" *ngIf="!show_grn_table && !show_product_goods_table && is_data_available">
    <div class="col">
      <mat-accordion>
        <mat-expansion-panel *ngFor="let product_group of by_product_group_list" style="margin-bottom: 1%;">
          <mat-expansion-panel-header style="padding: 30px;">
            <mat-panel-title>
              {{product_group['name']}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <table class="table table-bordered table-hovered">
            <thead>
              <tr>
                <th class="table-width">S. No</th>
                <th class="table-width">Product Name</th>
                <th class="table-width">In Stock</th>
                <th class="table-width">Orderable Quantity</th>
                <th class="table-width">History</th>
              </tr>
            </thead>
            <tbody *ngFor="let product of by_product_dict[product_group['id']]; let product_index=index">
              <tr>
                <td class="table-width">{{product_index + 1}}</td>
                <td class="table-width">{{product['name']}}</td>
                <td class="table-width">{{product['quantity_now']}}</td>
                <td class="table-width">{{product['avilable_quantity_after_order']}}</td>
                <td class="table-width">
                  <button mat-button (click)="serveGoodsRecord(product)"
                    style="background: #ec88bf;border-radius: 10px; font-size: 12px;">History</button>

                </td>
              </tr>
            </tbody>
          </table>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <span *ngIf="!is_previous_sale_closed">
    <div class="row">
      <div class="col" style="text-align: center;">
        <label style="color: #3835ff; font-size: 30px;">Previous Sale was not closed. Please Close that and order <br>
          <button mat-raised-button style="background: green; color: white;"
            (click)="saleClosedCalled(previous_date)">Close - {{previous_date | date}} Sale</button>
        </label>
      </div>
    </div>
  </span>
  <span *ngIf="is_previous_sale_closed">
    <span *ngIf="is_today_sale_closed">
      <div class="row">
        <div class="col" style="text-align: center;">
          <label style="color: #3835ff; font-size: 30px;">Today Sale was closed @
            {{today_sale_close_details['closed_at'] |
            date}} by {{today_sale_close_details['closed_by']}} <br>
          </label>
        </div>
      </div>
    </span>
    <span *ngIf="!is_today_sale_closed">
      <div class="row" *ngIf="show_grn_table">
        <div class="col-sm-2 col-lg-2" (click)="enableGrn()">
          <i class="material-icons" style="margin-left: 2%; font-size:46px;cursor: pointer;">arrow_back</i>
        </div>
        <div class="col-sm-6 col-lg-6">
          <p class="text-center" style="font-size: 30px;">New GRN</p>
        </div>
        <div class="col-sm-4 col-lg-4"></div>
      </div>
      <div class="card" style="padding:25px" *ngIf="show_grn_table">
        <div class="row" *ngIf="grn_number == null">
          <div class="col">
            <button mat-button (click)="serveGrnNumber()"
              style="background: #c5ec88;border-radius: 10px; font-size: 23px;">Generate GRN</button>
          </div>
        </div>
        <span *ngIf="grn_number != null">
          <div class="row">
            <div class="col">
              <label style="font-size: 23px;font-weight: 500; color: #278ecd;">{{grn_number}}</label> &nbsp; &nbsp;
              <label style="font-size: 23px;font-weight: 500; color: #278ecd;">{{grn_date | date}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-5" style="background: #fff1e1; display: block; padding: 15px;">
              <div class="row">
                <div class="col-5">
                  <label>Purchase Company <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                  <mat-select [(ngModel)]="source"
                    style="border: 1px solid; border-radius: 10px; text-align: center; padding: 10px;">
                    <mat-option *ngFor="let purchase_company of purchase_company_list" [value]="purchase_company">
                      {{purchase_company.company_name}}
                    </mat-option>
                  </mat-select> &nbsp; &nbsp;
                </div>
                <div class="col-2" style="margin-top: 5%;">
                  <i class="material-icons" style="margin-left: 2%; font-size:46px;cursor: pointer;"
                    (click)="newPurchaseCompany()">add</i>
                </div>
                <div class="col-5" *ngIf="source !== null" style="margin-top: 5%;">
                  <label><b>GST No.</b> :&nbsp; {{ source['gst_number'] }}</label><br>
                  <label><b>Pan No.</b> :&nbsp; {{ source['pan_number'] }}</label>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <label>Bill Number <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                  <input style="border: 1px solid; border-radius: 10px; text-align: center;"
                    [(ngModel)]="bill_number" />
                </div>
                <div class="col-6">
                  <label>Bill Date <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                  <input type="date" style="border: 1px solid; border-radius: 10px; text-align: center;"
                    [(ngModel)]="bill_date" />
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <label>PO Number</label>
                  <input type="text" style="border: 1px solid; border-radius: 10px; text-align: center;"
                    [(ngModel)]="po_number" />
                </div>
                <div class="col-6">
                  <label>PO Date</label>
                  <input type="date" style="border: 1px solid; border-radius: 10px; text-align: center;"
                    [(ngModel)]="po_date" />
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <label>DC Number</label>
                  <input type="text" style="border: 1px solid; border-radius: 10px; text-align: center;"
                    [(ngModel)]="dc_number" />
                </div>
                <div class="col-6">
                  <label>DC Date</label>
                  <input type="date" style="border: 1px solid; border-radius: 10px; text-align: center;"
                    [(ngModel)]="dc_date" />
                </div>
              </div>
              <br>
            </div>
            <div class="col-7" style="background: #c2d7e4;display: block;padding: 15px;">
              <mat-accordion>
                <div class="row">
                  <div class="col-6" *ngFor="let product_group of by_product_group_list">
                    <mat-expansion-panel style="margin-top: 3%;">
                      <mat-expansion-panel-header style="padding: 30px;">
                        <mat-panel-title>
                          {{product_group['name']}}
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="row">
                        <div class="col-12"
                          *ngFor="let product of by_product_dict[product_group['id']]; let product_index=index">
                          <mat-checkbox (change)="checkboxChanged($event, product)"
                            [(ngModel)]="by_product_dict[product_group['id']][product_index]['is_checked']">
                            {{product['name']}}
                          </mat-checkbox>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </div>
                </div>
              </mat-accordion>
            </div>
          </div><br>
          <div class="row">
            <table class="table table-bordered table-hovered">
              <thead>
                <tr>
                  <th>S. No</th>
                  <th>Product Name</th>
                  <th>Avail. Qty</th>
                  <th>Expiry</th>
                  <th>New Qty</th>
                  <th>Total Qty</th>
                  <th>Price (without GST)</th>
                  <th>CGST</th>
                  <th>SGST</th>
                  <th>IGST</th>
                  <th>Total Price</th>
                  <th>Remove</th>
                </tr>
              </thead>
              <!-- onkeypress="return event.charCode >= 48 && event.charCode <= 57" -->
              <tbody *ngFor="let product of selected_product_list; let product_index=index">
                <tr>
                  <td>{{product_index + 1}}</td>
                  <td>{{product['name']}}</td>
                  <td>{{product['quantity_now']}}</td>
                  <td><input type="date" [(ngModel)]="selected_product_list[product_index]['expiry_date']"
                      [min]="grn_date" (ngModelChange)="changeProductToValid(product_index)"
                      style="border: 1px solid; border-radius: 10px; text-align: center;" /></td>
                  <td><input type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      [(ngModel)]="selected_product_list[product_index]['new_quantity']"
                      (ngModelChange)="changeProductToValid(product_index)"
                      style="border: 1px solid; border-radius: 10px; text-align: center;" /></td>
                  <td>{{addNewAndOldQty(product_index)}}</td>
                  <!-- <td><input type="number" [(ngModel)]="selected_product_list[product_index]['price_per_unit']"
                      (ngModelChange)="changeProductToValid(product_index)"
                      style="border: 1px solid; border-radius: 10px; text-align: center;" /></td> -->
                  <td><input type="number" [(ngModel)]="selected_product_list[product_index]['price']"
                      (ngModelChange)="changeProductToValid(product_index)"
                      style="border: 1px solid; border-radius: 10px; text-align: center;" /></td>
                  <td><input type="number" [(ngModel)]="selected_product_list[product_index]['cgst_value']"
                      [style.background]="checkSGSTCGSTDisable(product_index) ? 'lightgray': 'none' "
                      (ngModelChange)="changeProductToValid(product_index)"
                      [disabled]="checkSGSTCGSTDisable(product_index)"
                      style="border: 1px solid; border-radius: 10px; text-align: center;" /><br>
                    <label> <b>Ref.</b> {{ selected_product_list[product_index]['default_cgst_value'] | currency:'INR'
                      }}</label>
                  </td>
                  <td><input type="number" [(ngModel)]="selected_product_list[product_index]['sgst_value']"
                      [style.background]="checkSGSTCGSTDisable(product_index) ? 'lightgray': 'none' "
                      (ngModelChange)="changeProductToValid(product_index)"
                      [disabled]="checkSGSTCGSTDisable(product_index)"
                      style="border: 1px solid; border-radius: 10px; text-align: center;" /><br>
                    <label> <b>Ref.</b> {{ selected_product_list[product_index]['default_sgst_value'] | currency:'INR'
                      }}</label>
                  </td>
                  <td>
                    <input type="number" [(ngModel)]="selected_product_list[product_index]['igst_value']"
                      [style.background]="checkIGSTDiable(product_index) ? 'lightgray': 'none' "
                      [disabled]="checkIGSTDiable(product_index)" (ngModelChange)="changeProductToValid(product_index)"
                      style="border: 1px solid; border-radius: 10px; text-align: center;" /><br>
                  </td>
                  <td>{{product['total_price'] | currency:'INR'}}</td>
                  <td>
                    <mat-icon aria-hidden="false" aria-label="Example home icon"
                      style="cursor: pointer; background: red;border-radius: 100%; color: white; float: right; margin-left: 10px;"
                      (click)="removeCalled(product_index)">
                      close</mat-icon>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </span>
        <footer *ngIf="selected_product_list.length !== 0">
          <div class="row">
            <div class="col" style="text-align: center;">
              <button [disabled]="checkValidForUpdate()" onclick="this.disabled=true" mat-button (click)="updateCalled()"
                style="background: #4ad8a9;border-radius: 10px; font-size: 15px;">Create</button>
            </div>
          </div>
        </footer>
      </div>
    </span>
  </span>
  <div class="row" *ngIf="show_product_goods_table" id="history">
    <div class="col-sm-2 col-lg-2" (click)="enableProductGoods()">
      <i class="material-icons" style="margin-left: 2%; font-size:46px;cursor: pointer;">arrow_back</i>
    </div>
    <div class="col-sm-6 col-lg-6">
      <p class="text-center" style="font-size: 30px;">{{selected_product_name}}</p>
    </div>
    <div class="col-sm-4 col-lg-4"></div>
  </div>
  <div class="row" *ngIf="show_product_goods_table">
    <div class="col">
      <table class="table table-bordered table-hovered">
        <thead style="background: #c8cec2;">
          <tr>
            <th>S. No</th>
            <th>GRN Number</th>
            <th>GRN Date</th>
            <th>Purchase Company</th>
            <th>PO Number</th>
            <th>PO Date</th>
            <th>DC Number</th>
            <th>DC Date</th>
            <th>Expiry Date</th>
            <th>Quantity Entered</th>
            <th>In Stock</th>
            <th>Price (Without GST)</th>
            <th>Total Price</th>
            <th>Last Modified Time</th>
            <th>Added By</th>
          </tr>
        </thead>
        <tbody *ngFor="let product_goods of product_goods_record; let data_index=index">
          <tr>
            <td>{{data_index + 1}}</td>
            <td>{{product_goods['grn_number']}}</td>
            <td>
              <span *ngIf="product_goods['grn_date'] !== 0">
                {{product_goods['grn_date'] | date}}
              </span>
              <span *ngIf="product_goods['grn_date'] == 0">
                -
              </span>
            </td>
            <td>{{product_goods['purchase_company']}}</td>
            <td>{{product_goods['po_number']}}</td>
            <td>
              <span *ngIf="product_goods['po_date'] !== 0">
                {{product_goods['po_date'] | date}}
              </span>
              <span *ngIf="product_goods['po_date'] == 0">
                -
              </span>
            </td>
            <td>
              <span *ngIf="product_goods['dc_number'] !== 0">
                {{product_goods['dc_number']}}
              </span>
              <span *ngIf="product_goods['dc_number'] == 0">
                -
              </span>
            </td>
            <td>
              <span *ngIf="product_goods['dc_date'] !== 0">
                {{product_goods['dc_date'] | date}}
              </span>
              <span *ngIf="product_goods['dc_date'] == 0">
                -
              </span>
            </td>
            <td>
              <span *ngIf="product_goods['expiry_date'] !== 0">
                {{product_goods['expiry_date'] | date}}
              </span>
              <span *ngIf="product_goods['expiry_date'] == 0">
                -
              </span>
            </td>
            <td>{{product_goods['quantity_at_receipt']}}</td>
            <td>{{product_goods['quantity_now']}}</td>
            <td>{{product_goods['price']}}</td>
            <td>{{product_goods['total_price']}}</td>
            <td>
              <span *ngIf="product_goods['quantity_now_time'] !== 0">
                {{product_goods['quantity_now_time'] | date : 'medium'}}
              </span>
              <span *ngIf="product_goods['quantity_now_time'] == 0">
                -
              </span>
            </td>
            <td>{{product_goods['created_by']}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
